import React, { Component } from 'react';
import Button from 'components/button/button'

import FileFileVersion from './file-versions-file'

import { clone } from 'lodash'

class FileVersions extends Component {
    deleteVersion = version => {
        const {
            file,
            openModal
        } = this.props

        const data = {
            fileId: file.id,
            version
        }

        openModal('delete', 'version', data)
    }

    render() {
        const {
            file,
        } = this.props

        let reversedFiles = clone(file.versions)
        reversedFiles.reverse()

        return (
            <div className="file-versions">
                { file.versions ?
                    <ul className="file-versions-list">
                        {reversedFiles.map(id => (
                            <FileFileVersion 
                                key={id} 
                                id={id} 
                                deleteVersion={this.deleteVersion} 
                            />
                        ))}
                    </ul> 
                    :
                    <div>Loading...</div>
                }
            </div>
        )
    }
}

export default FileVersions


// WEBPACK FOOTER //
// ./src/sections/projects/project/project-files/tabs/file-versions.jsx